import button_labels from './button_labels';

export default {
  button_labels,
};
